module.exports = __webpack_public_path__ + "fonts/Mount-Regular.c550693.woff2";